import React, { FC, useCallback } from "react";
import { LoadingSpinner, PageAlert } from "@xapp/components";
import { logout } from "auth";
import { useGetUserProfileQuery } from "generated/graphql";
import { useDispatch, useSelector } from "react-redux";
import { Credentials, State } from "redux/state";
import { Settings } from "../components/Settings";

export const SettingsContainer: FC = () => {

    const credentials = useSelector<State, Credentials>(state => state.auth.credentials);

    const [getProfile] = useGetUserProfileQuery({
        requestPolicy: "cache-and-network",
        variables: {
            jwt: credentials.accessToken
        }
    });

    const dispatch = useDispatch();

    const handleLogout = useCallback(() => {
        dispatch(logout());
    }, [dispatch]);

    const { data, error, fetching } = getProfile;

    if (fetching) {
        return (<LoadingSpinner loadingText={"Getting your profile"} />);
    }

    if (error) {
        return (<PageAlert background={"orange"}><p>We had an error requesting this information. {error.message} You can try logging in again <a href="/login">here.</a></p></PageAlert>);
    }

    const profile = data.profile;

    return (<Settings profile={profile} onLogout={handleLogout} />);
};
